
import axios from "axios";
import { API_URL } from '../../config/runtimeConfig';
import { getStatistiquesFailure, getStatistiquesStart, getStatistiquesSuccess } from "./StatistiqueActions";

const axiosInstance = axios.create({
    baseURL: API_URL,
});

export const getStatistiques = async(dispatch)=>{
    dispatch(getStatistiquesStart());
    try{
        const res = await axiosInstance.get(`/user/statistique/agent`,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getStatistiquesSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(getStatistiquesFailure(err.response.data.message))
        }else{
            dispatch(getStatistiquesFailure("Unkown Error"))
        }
    }
}